<template>
	<div>
		<field-errors v-if="hasSubmittedForm" :form="validation.form" field="access_type"></field-errors>
		<div class="input-container">
			<div class="input-title">Type Of Access</div>
			<label class="input-radio">
				<input type="radio" name="access_type" v-model="value.access_type" :value="ACCESS_TYPE.ADMIN">
				<span class="radio-checkmark"></span>
				<div class="radio-text">Administrator</div>
			</label>
			<label class="input-radio">
				<input type="radio" name="access_type" v-model="value.access_type" :value="ACCESS_TYPE.FULL">
				<span class="radio-checkmark"></span>
				<div class="radio-text">Full Access</div>
			</label>
			<label class="input-radio">
				<input type="radio" name="access_type" v-model="value.access_type" :value="ACCESS_TYPE.BASIC">
				<span class="radio-checkmark"></span>
				<div class="radio-text">Partial Access</div>
			</label>
		</div>
		<slide-up-down :active="hasFullAccess && !hasAdminAccess" :duration="400">
			<div class="input-container">
				<div class="input-static-text">This user will have access to all functionality, but will not be authorized to manage users.</div>
			</div>
		</slide-up-down>
		<slide-up-down :active="hasAdminAccess" :duration="400">
			<div class="input-container">
				<div class="input-static-text">This user will have unrestricted access to all functionality.</div>
			</div>
		</slide-up-down>
		<slide-up-down :active="!hasFullAccess" :duration="400">
			<div class="input-container">
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="view_inquiries" name="can_view_inquiries" v-model="value.permissions.inquiries">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="view_inquiries" class="input-checkbox-text">Allow this user to view web inquiries</label>
				</div>
			</div>
			<div class="input-container">
				<div class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" id="view_dashboard" name="can_view_dashboard" v-model="value.permissions._dashboard">
							<span class="checkmark"></span>
						</label>
					</span>
					<label for="view_dashboard" class="input-checkbox-text">Allow this user to view the dashboard</label>
				</div>
			</div>
			<div v-if="modules.length > 0" class="input-container">
				<div class="input-title">Modules</div>

				<div v-for="module in realModules" :key="`module-${ module.id }`" class="input-checkbox">
					<span class="checkmark-container">
						<label class="checkbox">
							<input type="checkbox" :id="`module-${ module.id }`" name="modules" v-model="value.permissions[ module.slug ]">
							<span class="checkmark"></span>
						</label>
					</span>
					<label :for="`module-${ module.id }`" class="input-checkbox-text"><span v-if="module.is_nav_heading === 1" style="font-weight:900;">Nav Title<span class="fa fa-arrow-right" style="padding:0px 7.5px;"></span></span>{{ module.name }}</label>
				</div>
			</div>
		</slide-up-down>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import { ACCESS_TYPE } from '@/constants/connections';

export default {

	props: [ 'value', 'hasSubmittedForm', 'user', 'validation' ],

	data() {
		return {
			ACCESS_TYPE,
		};
	},

	computed: {

		...mapGetters(['modules']),

		realModules() {
			return this.modules;
		},

		hasFullAccess() {
			return [ACCESS_TYPE.ADMIN, ACCESS_TYPE.FULL].indexOf(this.value.access_type) !== -1;
		},

		hasAdminAccess() {
			return this.value.access_type === ACCESS_TYPE.ADMIN;
		},

	},

};

</script>
